module.exports = __webpack_public_path__ + "static/media/test-giraffe.26fdbe93.jpg";